import { atom } from "@reatom/core"

import { SurveyQuestion } from "modules/NewClientSurvey/common/interface"
import { SurveyAnswersStorage } from "modules/NewClientSurvey/common/utils"

const dataStorage = SurveyAnswersStorage.getInstance().get()

export const questionAtom = atom<SurveyQuestion>(
    dataStorage?.currentQuestion || ({} as SurveyQuestion),
    "question"
)

questionAtom.onChange((ctx, state) =>
    SurveyAnswersStorage.getInstance().updateStore("currentQuestion", state)
)
